import React from "react";
import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

export default function (handleClick, renderable) {
  return {
    id: "deleteAction",
    isAction: true,
    onClick: handleClick,
    path: "",
    renderable,
    renderer: () => (
      <Buttons.Danger inverse rounded>
        <Icons.Close />
      </Buttons.Danger>
    )
  };
}
